import React from 'react';
import { makeStyles } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import { ReactComponent as NoVisitIcon } from '../../resources/images/noVisit.svg';
import { EmptyItemContent } from '../utilities/commonUtilities/CardItem';
import { styleBreakDesktop } from '../utilities/layouts/Globals';
import { NO_VISIT_DESCRIPTION } from '../../resources/messages.json';

const useStyles = makeStyles(theme => ({
    title: {
        marginBottom: theme.spacing(1),
    },
    message: {
        [styleBreakDesktop(theme)]: {
            maxWidth: '528px',
        },
    },
}));

export function NoVisitSubPage() {
    const title = 'Setting up your homepage';
    const message = NO_VISIT_DESCRIPTION;
    const classes = useStyles();
    return (
        <Box display="flex" justifyContent="center">
            <Box display="flex" flexDirection="column" mt={8}>
                <EmptyItemContent Image={NoVisitIcon} title={title} message={message} style={classes} />
            </Box>
        </Box>
    );
}
